import { useEffect, useState } from 'react';
import { TimedProgress } from '../common';
import { getAIEstimatedDurationMs } from '../../utils/aiEstimate';
import { BackgroundJob } from '../../types';

const DEFAULT_ESTIMATE_MS = 30000;

export function JobTimedProgress({ job, fallbackMs = DEFAULT_ESTIMATE_MS }: { job: BackgroundJob, fallbackMs?: number }) {
  const [estimate, setEstimate] = useState<number>(job.estimatedDurationMs || fallbackMs);
  useEffect(() => {
    if (!job.estimatedDurationMs && job.jobType) {
      let mounted = true;
      getAIEstimatedDurationMs({ requestType: job.jobType }).then((val) => {
        if (mounted && val) setEstimate(val);
      });
      return () => { mounted = false; };
    }
  }, [job.estimatedDurationMs, job.jobType]);
  return (
    <TimedProgress
      estimatedDurationMs={estimate}
      startTime={job.startedAt || job.createdAt}
      serverProgress={job.progress}
      isCompleted={job.status === 'completed'}
      isFailed={job.status === 'failed'}
      errorMessage={job.errorMessage}
    />
  );
}
